import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModules } from '@SharedModules/shared-modules.module';
import { PrimengModule } from '@SharedModules/primeng.module';
import { TableDynamicComponent } from '@sharedComponents/table-dynamic/table-dynamic.component';
import { PopoverModule } from 'primeng/popover';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';

import { InventoryRoutingModule } from './inventory-routing.module';
import { InventoryComponent } from './inventory.component';
import { TableInventoryComponent } from './components/table-inventory/table-inventory.component';
import { TableItemsComponent } from './components/table-items/table-items.component';
import { TableStockMovementsComponent } from './components/table-stock-movements/table-stock-movements.component';
import { ModalBasicComponent } from '@sharedComponents/modal-basic/modal-basic.component';
import { DashboardInventoryComponent } from './components/dashboard-inventory/dashboard-inventory.component';
import { QuickActionsComponent } from './components/quick-actions/quick-actions.component';
import { TableTestItemsSummaryComponent } from './components/table-test-items-summary/table-test-items-summary.component';
import { TableStockTransfersComponent } from './components/table-stock-transfers/table-stock-transfers.component';
import { StockTransferFormComponent } from './components/stock-transfer-form/stock-transfer-form.component';

@NgModule({
  declarations: [
    InventoryComponent,
    TableInventoryComponent,
    TableStockMovementsComponent,
    DashboardInventoryComponent,
    TableTestItemsSummaryComponent,
    TableStockTransfersComponent,
    StockTransferFormComponent
  ],
  imports: [
    CommonModule,
    InventoryRoutingModule,
    SharedModules,
    PrimengModule,
    FormsModule,
    ReactiveFormsModule,
    TableDynamicComponent,
    ModalBasicComponent,
    TableItemsComponent,
    QuickActionsComponent,
    PopoverModule,
    TooltipModule,
    ButtonModule
  ]
})
export class InventoryModule { }
